import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { Button } from "../ui/button";

const FinalCTA = ({ onDiagnosticClick, onDemoClick }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 relative overflow-hidden"
      data-testid="final-cta-section"
    >
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] radial-gradient opacity-40" />

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="mono-label">Start Your AI Journey</span>
          
          <h2 className="mt-6 text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight text-white font-['Outfit'] leading-tight">
            See where AI can create{" "}
            <span className="gradient-text">leadership value first</span>
          </h2>
          
          <p className="mt-6 text-base md:text-lg text-[#A1A1AA] max-w-xl mx-auto">
            Start with a diagnostic that shows what your enterprise can support today — and how 
            OnTenacity can turn that into AI-powered executive intelligence.
          </p>

          {/* CTAs */}
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={onDiagnosticClick}
              className="btn-primary px-8 py-4 rounded-full text-base font-semibold flex items-center gap-2 group w-full sm:w-auto"
              data-testid="final-diagnostic-btn"
            >
              Start AI Diagnostic
              <ArrowRight 
                size={20} 
                className="transition-transform group-hover:translate-x-1" 
              />
            </Button>
            <Button
              variant="outline"
              onClick={onDemoClick}
              className="btn-secondary px-8 py-4 rounded-full text-base w-full sm:w-auto"
              data-testid="final-demo-btn"
            >
              Request Demo
            </Button>
          </div>

          {/* Trust Line */}
          <p className="mt-8 text-sm text-[#71717A]">
            OnTenacity is an AI-powered, source-backed executive intelligence platform — and the 
            first practical step in the enterprise AI journey.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
